import React from "react"
import styled from "styled-components"
import Spinner from "components/common/spinner"

const AvatarContainer = styled.div`
  height: 90px;
  width: 90px;
  margin-right: auto;
  margin-left: auto;
  height: 100%;
  width: 100%;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  position: relative;

  .initials {
    margin: 0;
    color: #fff;
    cursor: pointer;
  }

  .avatar-icon {
    height: 100%;
    width: 100%;
    object-fit: cover;
    border-radius: inherit;
  }

  &:hover {
    .edit-overlay {
      opacity: 1;
    }
  }

  .edit-overlay {
    opacity: 0;
    position: absolute;
    right: 0;
    top: 0;
    padding: 8px;
    font-size: 14px;
    border-radius: 50%;
    background-color: #ffffff;
    box-shadow: 0 0 12px -2px rgba(0, 0, 0, 0.4);
  }
`

function getInitials(name, delimeter) {
  if (name) {
    var array = name.split(delimeter)
    switch (array.length) {
      case 1:
        return array[0].charAt(0).toUpperCase()
      default:
        return (
          array[0].charAt(0).toUpperCase() +
          array[array.length - 1].charAt(0).toUpperCase()
        )
    }
  }
  return false
}

class Avatar extends React.Component {
  handleEditPhoto = () => {
    const { onEditPhoto } = this.props

    if (onEditPhoto) {
      onEditPhoto()
    }
  }

  renderAvatar() {
    const { profileDetails } = this.props

    if (profileDetails?.photo) {
      return (
        <img
          className="avatar-icon"
          src={profileDetails.photo}
          alt={"avatar-icon"}
          onError={(e) =>
            (e.target.src =
              "https://cdn.pixabay.com/photo/2016/08/08/09/17/avatar-1577909_1280.png")
          }
        />
      )
    } else {
      let name =
        profileDetails.first_name && profileDetails.last_name
          ? profileDetails.first_name.concat(" ", profileDetails.last_name)
          : profileDetails.username
      let initials = getInitials(name, " ")
      return <p className="initials">{initials}</p>
    }
  }

  render() {
    const { isLoading, schoolColor } = this.props
    return (
      <AvatarContainer
        style={{
          background: schoolColor,
        }}
      >
        {isLoading ? <Spinner isFetching={isLoading} /> : this.renderAvatar()}
        <div className="edit-overlay" onClick={this.handleEditPhoto}>
          <span style={{ fontSize: "14px" }} className="icon-edit" />
        </div>
      </AvatarContainer>
    )
  }
}

export default Avatar
